export const darkThemeVariables = {
    '--main-accent-color': '#88B8FF',
    '--main-title-color': '#F6F5F7',
    '--main-text-color': '#C5BFCB',
    '--footer-one-line-color': 'rgba(177, 150, 255, 0.10)',
    '--main-button-border-radius': '10px',
    '--main-button-background': 'linear-gradient(267deg, #6442EC 0%, #5F52F1 100%)',
    '--main-button-box-shadow': 'initial',
    '--main-button-text': '#F6F5F7',
    '--main-button-text-transform': 'initial',
    '--global-web-app-loader-border': 'rgb(62, 32, 183)',
    '--global-web-app-loader-border-bottom': 'rgb(69, 72, 215)',
    '--global-web-app-loader-background': 'rgba(32, 19, 71, 0.8)',
    '--progres-bar': '#364152',
    '--progres-bar-active': '#4E95FF',
    '--quiz-custom-progress-bar': '#364152',
    '--quiz-custom-progress-bar-active': '#FFF',
    '--quiz-custom-progress-bar-part-text': '#FFF',
    '--quiz-custom-progress-bar-part-text-newt2': '#FFF',
    '--quiz-go-back-button-background': 'rgb(25, 27, 34)',
    '--quiz-go-back-button-shadow': '#202939',
    '--quiz-go-back-button-text': '#FFF',
    '--quiz-info-type-text': '#FFF',
    '--background-color': '#0D121C',
    '--title-default-color': '#FFF',
    '--title-accent-color': '#88B8FF',
    '--sub-title-default-color': '#9AA4B2',
    '--sub-title-default-color-quiz': '#CDD5DF',
    '--radio-button-background-color-quiz': '#202939',
    '--radio-button-border-color-quiz': '#4B5565',
    '--radio-button-border-hover-color-quiz': '#4E95FF',
    '--radio-button-border-hover-color-quiz-new-h2': 'rgba(153, 161, 186, 1)',
    '--radio-button-border-hover-color-quiz-new-s': 'rgba(153, 161, 186, 1)',
    '--kickstarter-main-block-border': '#4B5565',
    '--kickstarter-main-block-background-gradient-1': '#202939',
    '--kickstarter-main-block-background-gradient-2': '#59729F',
    '--game-button-main-color': '#202939',
    '--game-button-main-border': '#4B5565',
    '--game-button-main-shadow': '#03D4AF80',
    '--game-button-main-shadow-visual-game': 'rgba(3, 212, 175, 0.50)',
    '--game-button-main-shadow-number-face-game': 'rgba(78, 149, 255, 0.50)',
    '--game-background-main-color': '#202939',
    '--game-tile-clicked-before': '#4BEEB3',
    '--game-tile-clicked-before-shadow': '#4BEEB3',
    '--game-tile-clicked-before-sequence': 'rgba(3, 212, 175, 0.10)',
    '--game-tile': '#364152',
    '--game-tile-before-sequence': '#2263C3',
    '--game-tile-choice-sequence': '#88B8FF',
    '--game-tile-hover': '#9AA4B2',
    '--game-progress-bar-background': '#EEF2F6',
    '--game-progress-bar-progress': '#3989FF',
    '--game-tile-hint-background': 'rgb(89, 19, 155)',
    '--game-visual-element-background': '#202939',
    '--social-proof-background': 'rgba(255, 255, 255, 0.05)',
    '--loader-progress': '#3989FF',
    '--loader-progress-background': '#4B5565',
    '--loader-background': '#202939',
    '--loader-review-background': '#364152',
    '--new-s-loader-progress': '#4BEEB3',
    '--new-s-loader-progress-background': 'rgba(232, 237, 255, 0.2)',
    '--new-s-loader-progress-text': '#4BEEB3',
    '--new-s-loader-title-accent': '#4BEEB3',
    '--new-s-loader-secondary-text': '#E8EDFF',
    '--new-s-loader-review-background': 'rgba(232, 237, 255, 0.2)',
    '--new-h2-loader-progress': '#4BEEB3',
    '--new-h2-loader-progress-background': 'rgba(232, 237, 255, 0.2)',
    '--new-h2-loader-progress-text': '#4BEEB3',
    '--new-h2-loader-title-accent': '#4BEEB3',
    '--new-h2-loader-secondary-text': '#E8EDFF',
    '--new-h2-loader-review-background': 'rgba(232, 237, 255, 0.2)',
    '--social-proof-memory-level-background-gradient-1': '#232934',
    '--social-proof-memory-level-background-gradient-2': '#3F4757',
    '--social-proof-left-text': '#D98647',
    '--social-proof-green-text': '#03D4AF',
    '--social-proof-bottom-text': '#C3C1C8',
    '--plan-page-top-discount-background': 'rgba(21, 19, 32, 0.90)',
    '--plan-page-top-discount-bottom-border': 'rgba(177, 150, 255, 0.10)',
    '--plan-page-paywall-background-newt2': '#322E4B',
    '--plan-page-paywall-shadow-newt2': 'null',
    '--plan-page-paywall-promocode-border-newt2': '#4A417A',
    '--plan-page-paywall-promocode-background-newt2': '#3E3A5B',
    '--plan-page-paywall-promocode-text-container-newt2': '#575278',
    '--plan-page-paywall-timer-container-border-newt2': '#CF5C5C',
    '--plan-page-paywall-timer-container-background-newt2': '#785253',
    '--plan-page-img-title-default-color-newt2': '#F6F5F7',
    '--plan-page-img-sub-title-default-color-newt2': '#C5BFCB',
    '--plan-page-within-container-background': '#322E4B',
    '--plan-page-within-element-background': 'rgba(232, 237, 255, 0.20)',
    '--plan-page-img-module-border-background': 'rgba(255, 255, 255, 0.00)',
    '--plan-page-img-module-background-gradient-1': 'rgba(26, 23, 41, 0.95)',
    '--plan-page-img-module-background-gradient-2': 'rgba(53, 46, 92, 0.95)',
    '--plan-page-img-module-title-default-color': '#F6F5F7',
    '--plan-page-img-module-bage-background': '#504681',
    '--plan-page-img-module-left-bage-background': '#423C61',
    '--plan-page-img-module-left-bage-text': '#F6F5F7',
    '--plan-page-img-module-right-bage-background': '#4BEEB3',
    '--plan-page-img-module-right-bage-text': '#151320',
    '--plan-page-img-module-bage-text-bottom': '#F6F5F7',
    '--plan-page-trust-memoryos-text': '#C5BFCB',
    '--plan-page-option-background-gradient-1': 'rgba(68, 61, 105, 0.4)',
    '--plan-page-option-background-gradient-2': 'rgba(50, 45, 79, 0.4)',
    '--plan-page-option-background-border': '#7268a5',
    '--plan-page-option-background-active-gradient-1': '#024960',
    '--plan-page-option-background-active-gradient-2': '#413186',
    '--plan-page-option-background-active-border': '#ffffff',
    '--plan-page-option-most-popular-background': '#665b8f',
    '--plan-page-option-most-popular-text': '#ffffff',
    '--plan-page-option-title': '#ffffff',
    '--plan-page-option-save-bage-background': 'rgba(75, 238, 179, 0.70)',
    '--plan-page-option-save-bage-text': '#151320',
    '--plan-page-option-part-text': '#C6B9FF',
    '--plan-page-option-secured-text': '#C5BFCB',
    '--plan-page-option-safe-background': 'rgba(75, 238, 179, 0.2)',
    '--plan-page-option-safe-text': '#4beeb3',
    '--plan-page-option-details-text': '#C5BFCB',
    '--plan-page-down-sale-popup-accent-text': '#4beeb3',
    '--plan-page-title': '#F6F5F7',
    '--plan-page-title-accent': '#88B8FF',
    '--plan-page-sub-title': '#C5BFCB',
    '--plan-page-header-background': '#000000',
    '--plan-page-promocode-background': 'rgba(50,46,75, 0.9)',
    '--plan-page-promocode-border': '#4A417A',
    '--plan-page-element-background': 'rgba(50,46,75, 1)',
    '--plan-page-memorize-elements-background': 'rgba(232,237,255, 0.2)',
    '--plan-page-open-text': '#B196FF',
    '--plan-page-one-line-border': '#2D2948',
    '--plan-page-bottom-button-shadow-background': 'rgba(21, 19, 32, 0.90)',
    '--plan-page-viewing-page-counter-background': '#413186',
    '--plan-page-viewing-page-counter-text': '#F6F5F7',
    '--plan-page-options-container-shadow': 'rgba(137, 96, 255, 0.50)',
    '--plan-page-modal-background': 'rgb(50,46,75)',
    '--plan-page-review-arrow-background': 'none',
    '--plan-page-review-arrow-border': 'none',
    '--plan-page-options-secure-text': '#C5BFCB',
    '--plan-page-options-footer-safe-background': 'rgba(75, 238, 179, 0.20)',
    '--plan-page-options-footer-safe-text': '#4BEEB3',
    '--plan-page-button-newt2-background-gradient-1': '#5D53F0',
    '--plan-page-button-newt2-background-gradient-2': '#6242ED',
    '--payment-page-background-newt2': '#151320',
    '--payment-page-details-background-newt2': 'rgba(21, 19, 32, 0.80)',
    '--payment-page-checkbox-text-newt2': '#C5BFCB',
    '--plan-page-button-iq-test-background-gradient-1': '#5D53F0',
    '--plan-page-button-iq-test-background-gradient-2': '#6242ED',
    '--offer-page-price-text': '#8592C2',
    '--offer-page-cross-price-text': '#8592C2',
    '--offer-page-pagination-bullet': '#6B6B6B',
    '--offer-page-pagination-bullet-active': '#FFFFFF',
    '--offer-page-badge-newt2': 'rgba(247, 41, 0, 0.30)',
    '--offer-page-text-newt2': 'rgba(255, 255, 255, 0.80)',
    '--offer-page-subtitle-newt2': '#C5BFCB',
    '--offer-page-workbook-container-border-newt2': '#6C4B90',
    '--offer-page-workbook-badge-border-newt2': '#4A417A',
    '--offer-page-workbook-badge-background-newt2': '#6349A2',
    '--offer-page-workbook-main-block-newt2': '#322E4B',
    '--offer-page-badge-iq-test': 'rgba(247, 41, 0, 0.30)',
    '--offer-page-text-iq-test': 'rgba(255, 255, 255, 0.80)',
    '--offer-page-subtitle-iq-test': '#C5BFCB',
    '--offer-page-workbook-container-border-iq-test': '#6C4B90',
    '--offer-page-workbook-badge-border-iq-test': '#4A417A',
    '--offer-page-workbook-badge-background-iq-test': '#6349A2',
    '--offer-page-workbook-main-block-iq-test': '#322E4B',
    '--offer-page-paywall-title': '#98999B',
    '--offer-page-paywall-save-text': '#FFF',
    '--offer-page-paywall-save-text-border': '#AE1D00',
    '--offer-page-paywall-save-text-background': 'rgba(247, 41, 0, 0.30)',
    '--offer-page-scroll-button-background': 'rgba(13, 18, 28, 0.8)',
    '--offer-page-user-container-border': '#4A417A',
    '--offer-page-user-container-background': '#322E4B',
    '--offer-page-mastery-list-border': 'rgba(255, 255, 255, 0.00)',
    '--offer-page-mastery-list-background-gradient-1': 'rgba(26, 23, 41, 0.95)',
    '--offer-page-mastery-list-background-gradient-2': 'rgba(53, 46, 92, 0.95)',
    '--offer-page-loci-badge-background': 'rgba(247, 41, 0, 0.8)',
    '--signup-bottom-block-border': '#4A417A',
    '--signup-bottom-block-background': '#322E4B',
    '--thankyou-header-background': 'rgba(21, 19, 32, 0.90)',
    '--thankyou-page-one-line-border': 'rgba(177, 150, 255, 0.10)',
    '--thankyou-page-special-text': '#624aef',
    '--thankyou-page-sub-background-color-one': 'rgba(99, 191, 230, 0.10)',
    '--thankyou-page-sub-background-color-two': 'rgba(145, 162, 255, 0.10)',
    '--thankyou-page-sub-shadow': 'rgba(41, 30, 82, 0.70)',
    '--thankyou-page-sub-welcome-text': '#F6F5F7',
    '--thankyou-page-sub-text': '#B3A6FF',
    '--thankyou-page-sub-renew-test': '#FFF',
    '--thankyou-page-sub-loci-text': '#4BEEB3',
    '--thankyou-page-steps-header-text': '#F6F5F7',
    '--thankyou-page-step-border': 'rgba(93, 79, 172, 0.3)',
    '--thankyou-page-step-number-color-one': '#ffa800',
    '--thankyou-page-step-number-color-two': '#7c66f4',
    '--thankyou-page-step-header': '#F6F5F7',
    '--thankyou-page-step-regular-text': '#E8EDFF',
    '--thankyou-page-step-sub-title': '#88B8FF',
    '--thankyou-page-step-google-text': '#151320',
    '--thankyou-page-step-google-border': '#C4C8D9',
    '--thankyou-page-step-google-background': '#FFF',
    '--thankyou-page-step-apple-text': '#FFFFFF',
    '--thankyou-page-step-apple-background': '#ffffff1a',
    '--thankyou-page-step-download-button-border': '#696680',
    '--thankyou-page-step-download-button-background': 'rgba(21, 19, 32, 0.50)',
    '--thankyou-page-step-download-button-text-header': '#E8EDFF',
    '--thankyou-page-step-download-button-text-footer': '#E8EDFF',
    '--thankyou-page-step-block-background': 'rgba(113, 90, 255, 0.10)',
    '--thankyou-page-iq-test-border': 'rgba(32, 219, 255, 1)',
    '--thankyou-page-gamepad-background-gradient-1': 'rgba(40, 37, 53, 0.95)',
    '--thankyou-page-gamepad-background-gradient-2': 'rgba(58, 46, 110, 0.95)',
    '--thankyou-page-notification-container-background-gradient-1': '#322E48',
    '--thankyou-page-notification-container-background-gradient-2': '#322D4F',
    '--thankyou-page-notification-container-border': '#5D4FAC',
    '--thankyou-page-notification-container-text': '#F6F5F7',
    '--thankyou-page-bottom-header-button-text': '#F6F5F7',
    '--thankyou-page-bottom-button-text': '#E8EDFF',
    '--thankyou-page-bottom-button-background': 'rgba(21, 19, 32, 0.50)',
    '--regular-quiz-loader-popup-wrapper-background': 'rgba(13, 18, 28, 0.70)',
    '--regular-quiz-loader-popup-border': '#4B5565',
    '--regular-quiz-loader-popup-background': '#202939',
    '--regular-quiz-loader-popup-title': '#9AA4B2',
    '--regular-quiz-loader-popup-question': '#FFF',
    '--regular-quiz-loader-popup-button-text': '#FFF',
    '--regular-quiz-loader-popup-button-background': 'rgba(22, 22, 22, 0.3)',
    '--regular-quiz-loader-popup-button-background-active': 'rgba(22, 22, 22, 0.5)',
    '--regular-quiz-loader-popup-button-shadow': 'black',
    '--regular-quiz-loader-popup-button-shadow-active': 'black',
    '--regular-quiz-loader-hr-line': 'rgba(232, 237, 255, 0.2)',
    '--upsell-jonas-ai-header-button-text': 'rgba(255, 255, 255, 0.80)',
    '--upsell-jonas-ai-header-border-bottom': 'rgba(177, 150, 255, 0.10)',
    '--upsell-jonas-ai-badge-background': 'rgba(247, 41, 0, 0.30)',
    '--upsell-jonas-ai-message-border': '#4A417A',
    '--upsell-jonas-ai-message-background': '#322E4B',
    '--upsell-jonas-ai-chat-preview-background': 'linear-gradient(73deg, rgba(42, 24, 135, 0.95) 0%, rgba(80, 101, 161, 0.95) 0.01%, rgba(110, 64, 180, 0.95) 100%)',
    '--upsell-jonas-ai-feature-card-border': '#4A417A',
    '--upsell-jonas-ai-feature-card-background': '#322E4B',
    '--upsell-jonas-ai-feature-card-badge-background': '#665B8F',
    '--upsell-jonas-ai-payment-block-border': '#5D4FAC',
    '--upsell-jonas-ai-payment-block-background': 'linear-gradient(90deg, rgba(41, 31, 75, 0.50) 0%, #151320 68.01%)',
    '--upsell-jonas-ai-offer-price-background': 'rgba(247, 41, 0, 0.30)',
    '--upsell-jonas-ai-offer-text-color': '#FFF',
    '--upsell-jonas-ai-memory-grandmaster-background': 'linear-gradient(73deg, rgba(42, 24, 135, 0.95) 0%, rgba(80, 101, 161, 0.95) 0.01%, rgba(110, 64, 180, 0.95) 100%)',
    '--upsell-jonas-ai-feedback-border': '#5D4FAC',
    '--upsell-jonas-ai-feedback-background': 'linear-gradient(253deg, #322E48 0%, #322D4F 100%)',
    '--upsell-jonas-ai-shadow': 'linear-gradient(270deg, #151320 6.49%, rgba(21, 19, 32, 0) 95.19%)',
    '--upsell-jonas-ai-feedback-arrow-border': 'rgba(93, 79, 172, 0.5)',
    '--upsell-jonas-ai-feedback-arrow-background': 'linear-gradient(253.49deg, #3a2e7d 0%, #322d4f 100%), linear-gradient(252.29deg, rgba(93, 79, 172, 0.5) 0%, rgba(255, 255, 255, 0) 98.51%)',
    '--upsell-jonas-ai-feedback-arrow-background-hover': 'linear-gradient(253.49deg, #3a2e7d 0%, #7266b4 100%), linear-gradient(252.29deg, rgba(93, 79, 172, 0.5) 0%, rgba(255, 255, 255, 0) 98.51%)',
    '--upsell-jonas-ai-bottom-block-background': 'linear-gradient(253deg, rgba(42, 24, 135, 0.95) 0%, rgba(80, 101, 161, 0.95) 0.01%, rgba(110, 64, 180, 0.95) 100%)',
    '--upsell-jonas-ai-guarantee-background': 'linear-gradient(73deg, rgba(42, 24, 135, 0.95) 0%, rgba(80, 101, 161, 0.95) 0.01%, rgba(110, 64, 180, 0.95) 100%)',
    '--upsell-jonas-ai-scroll-button-background': 'rgba(13, 18, 28, 0.8)',
    '--reserve-page-accent-color': '#1BE0FF',
    '--reserve-page-top-header-background': 'rgba(21, 19, 32, 0.90)',
    '--reserve-page-top-header-border-bottom': 'rgba(177, 150, 255, 0.10)',
    '--reserve-page-top-component-border': '#465089',
    '--reserve-page-top-component-background': '#242c5b80',
    '--reserve-page-top-component-box-border': '#5D4FAC',
    '--reserve-page-top-component-box-background': 'linear-gradient(267deg, rgba(42, 31, 85, 0.50) 2.25%, #151320 106.97%)',
    '--reserve-page-jonas-component-box-shadow': '0 70px 200px 0 rgba(137, 96, 255, 0.36)',
    '--reserve-page-main-component-border': '#5D4FAC',
    '--reserve-page-main-component-background': 'linear-gradient(283deg, #2A1F55 -2.25%, #151320 20.58%)',
    '--reserve-page-main-component-box-shadow': 'initial',
    '--reserve-page-bottom-component-border': '93, 79, 172',
    '--reserve-page-bottom-component-background': 'linear-gradient(283.43deg, #2a1f55 -2.25%, #151320 20.58%)',
    '--waitlist-page-top-component-border': 'rgba(102, 96, 129, 0.2)',
    '--waitlist-page-top-component-background': 'linear-gradient(to right, rgb(35, 29, 63), rgb(69, 61, 104))',
    '--waitlist-page-video-box-shadow': '0 16px 60px 0 rgba(137, 96, 255, 0.30)',
    '--waitlist-page-within-memory-os-box-shadow': '0px 16px 120px 0px rgba(137, 96, 255, 0.3)',
    '--waitlist-page-within-memory-os-item-background': 'rgba(232, 237, 255, 0.2)',
    '--waitlist-page-award-box-background': 'linear-gradient(300.63deg, #2a1f55 -18.35%, #151320 50.76%), linear-gradient(264.02deg, rgba(93, 79, 172, 0.5) 4.74%, rgba(93, 79, 172, 0.15) 93.05%)',
    '--waitlist-page-award-box-border': '102, 96, 129',
    '--waitlist-page-award-box-border-left': '98, 94, 116',
    '--waitlist-page-more-effeciently-border': '#2D2948',
    '--waitlist-page-moew-effecientky-box-border': 'rgba(255, 255, 255, 0.2)',
    '--waitlist-page-moew-effecientky-box-background': 'linear-gradient(72.72deg, rgba(40, 37, 53, 0.95) 0%, rgba(58, 46, 110, 0.95) 100%), linear-gradient(89.88deg, rgba(255, 255, 255, 0) 0.1%, rgba(255, 255, 255, 0.2) 99.9%)',
    '--waitlist-page-moew-effecientky-box-shadow': 'linear-gradient(180deg, rgba(41, 31, 75, 0.25) 0%, #151320 54.89%), linear-gradient(252.29deg, rgba(93, 79, 172, 0.3) 0%, rgba(255, 255, 255, 0) 98.51%)',
    '--waitlist-page-feedback-border': '#5D4FAC',
    '--waitlist-page-feedback-background': 'linear-gradient(253deg, #322E48 0%, #322D4F 100%)',
    '--waitlist-page-slider-arrow-border': 'rgba(93, 79, 172, 0.5)',
    '--waitlist-page-slider-arrow-background': 'linear-gradient(253.49deg, #3a2e7d 0%, #322d4f 100%), linear-gradient(252.29deg, rgba(93, 79, 172, 0.5) 0%, rgba(255, 255, 255, 0) 98.51%)',
    '--waitlist-page-slider-arrow-background-hover': 'linear-gradient(253.49deg, #3a2e7d 0%, #7266b4 100%), linear-gradient(252.29deg, rgba(93, 79, 172, 0.5) 0%, rgba(255, 255, 255, 0) 98.51%)',
    '--waitlist-page-decoration-background': 'linear-gradient(270deg, #151320 6.49%, rgba(21, 19, 32, 0) 95.19%)',
    '--waitlist-page-offen-ask-border': '#5D4FAC',
    '--waitlist-page-offen-ask-background': 'linear-gradient(253deg, #322E48 0%, #322D4F 100%)',
    '--waitlist-page-viewing-box-background': '#413186',
    '--web-to-app-reading-text-color': '#CDD5DF',
    '--web-to-app-reading-border-color': '#4B5565',
    '--web-to-app-lessons-tab-border-color': '#CDD5DF',
    '--web-to-app-lessons-tab-color-active': '#202939',
    '--web-to-app-lessons-tab-background-active': '#FCFCFD',
    '--web-to-app-lessons-quote-background': '#2B528C',
    '--hp-downsale-popup-background': 'rgba(0, 0, 0, 0.80)',
    '--hp-downsale-popup-content-border': '#5D4FAC',
    '--hp-downsale-popup-content-border-radius': '16px',
    '--hp-downsale-popup-content-background': '#151320',
    '--hp-downsale-popup-content-box-shadow': 'initial',
    '--hp-downsale-popup-title-accent': '#4BEEB3',
    '--hp-downsale-popup-text': '#D1C1E5',
} as const;
